const PERMISSION_KEY= "core:user_cash_detail";
const PAGE_URL = {
    USER_CASH_DETAIL_PAGE: "/admin/core/user-cash-detail"
}

export {PERMISSION_KEY, PAGE_URL}

